<template>
	<div v-if="talisman" class="talisman">
		<div class="illustration" v-bg="'cards/talisman/' + talisman.slug + '.png'"></div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'talisman',
	props: {
		talisman: { default: null }
	},
	computed: {
		...mapGetters([ 'lang' ])
	}
}
</script>

<style lang="stylus" scoped>

.talisman
	width 120px
	height 120px
	.illustration
		absolute 0
		background center center no-repeat
		background-size contain

</style>
